import { Route, Routes, useLocation } from 'react-router-dom';
import React, { useRef } from 'react';
import Home from './pages/Home/Home';
import Download from './pages/Download/Download';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { bookTOC } from './data/bookTOC';
import About from './pages/About/About';
import ThoughtOfTheDay from './pages/ThoughtOfTheDay/ThoughtOfTheDay';
import TOTDPage from './pages/TOTDPage/TOTDPage';

function App() {
  const navbarRef = useRef<HTMLDivElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  return (
    <div className="app-container">
      <div className="main-content">
        <ScrollToTop />
        <Navbar ref={navbarRef} />
        <div className="mobile-padding">
          <Routes>
            <Route path="/" element={<Home navbarRef={navbarRef} footerRef={footerRef} />} />
            <Route path="/download" element={<Download />} />
            {bookTOC.map((chapter) => (
              <React.Fragment key={chapter.slug}>
                <Route
                  path={`/${chapter.slug}`}
                  element={React.createElement(chapter.Component)}  // Render the main chapter component
                />
                {chapter.subchapters &&
                  chapter.subchapters.map((subchapter) => (
                    <Route
                      key={subchapter.slug}
                      path={`/${chapter.slug}/${subchapter.slug}`}
                      element={React.createElement(subchapter.Component)}
                    />
                  ))}
              </React.Fragment>
            ))}
            <Route path="/about" element={<About />} />
            <Route path="/totd" element={<ThoughtOfTheDay />} />
            <Route path="/totd/:id" element={<TOTDPage />}/>
          </Routes>
        </div>
      </div>
      <Footer ref={footerRef} />
    </div>
  );
}

export default App;
